export const styles = {
  root: {
    position: 'sticky',
    bottom: 0,
    zIndex: 10,
    backgroundColor: '#eee',
    padding: '24px',
    //margin: '12px -24px -12px -24px',
    boxShadow: '0 -1px 12px rgba(70, 70, 70, 0.3)',
    marginTop: 'auto',
  },
}
